<template lang='pug'>
  div
    v-toolbar(dense)
      v-spacer
      v-spacer
      v-text-field#testsSearch(v-model='search' ref='search' placeholder='Search ("/" to focus)' hide-details prepend-inner-icon='search' clearable single-line)
    table-list(:headers='headers'
      :items='tests'
      :total='total'
      :loading='loading'
      :select-all='false'
      :has-selection='false'
      @update='update')
      template(v-slot:row='{item, index}')
        td
          router-link(v-if='item.account' :to='`/super/accounts/${item.account._id}`') {{item.account.name}}
        td {{item.name}}
        td {{item.description}}
        td
          display-tags(v-model='item.tags')
        td
          time-ago(:date='item.createdAt')
        td
          time-ago(:date='item.updatedAt')
        td {{item.retries}}
        td
          v-icon(small v-if='item.hardResetOnRetry') check
        td
          v-row(justify='end')
            v-menu(offset-y left)
              template(v-slot:activator='{on}')
                v-btn(text icon v-on='on' @click.native.stop='')
                  v-icon more_vert
              v-list
                v-list-item(@click='deleteTest(item)')
                  v-list-item-title
                    | Delete
      template(v-slot:item='{item}')
        v-row(no-gutters)
          v-col(cols='12').text-body-1.pa-3
            .text-subtitle-1 {{item.name}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Account:
              v-col
                router-link(v-if='item.account' :to='`/super/accounts/${item.account._id}`') {{item.account.name}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Description:
              v-col {{item.description}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Tags:
              v-col
                display-tags(v-model='item.tags')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Created:
              v-col
                time-ago-reverse(:date='item.createdAt')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Updated:
              v-col
                time-ago-reverse(:date='item.updatedAt')
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Retries:
              v-col {{item.retries}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Hard Reset:
              v-col
                v-icon(small v-if='item.hardResetOnRetry') check
            v-row(justify='end')
              v-menu(offset-y @click.native.stop='' left)
                template(v-slot:activator='{on}')
                  v-btn(text icon v-on='on')
                    v-icon more_vert
                v-list
                  v-list-item(@click='deleteTest(item)')
                    v-list-item-title
                      | Delete Test
        v-divider
</template>

<script>
import _ from 'lodash';
import SuperAdmin from '@/api/superAdmin';
import Notifications from '@/services/notification.service';
import TableMixin from '@/mixins/table.mixin';
import FocusMixin from '@/mixins/focus.mixin';
import TableList from '@/components/TableList';
import TimeAgo from '@/components/TimeAgo';
import TimeAgoReverse from '@/components/TimeAgoReverse';
import DisplayTags from '@/components/DisplayTags';

export default {
  name: 'SuperAdminTests',
  components: {DisplayTags, TimeAgoReverse, TimeAgo, TableList},
  mixins: [TableMixin, FocusMixin],
  methods: {
    async update(options) {
      this.limit = options.itemsPerPage;
      this.skip = options.itemsPerPage * (options.page - 1);
      this.sort = this.getSortFromOptions(options);
      return this.load();
    },
    async load() {
      this.loading = true;
      try {
        const {list, total} = await SuperAdmin.getTests({
          skip: this.skip,
          limit: this.limit,
          sort: this.sort,
          search: this.search
        });
        this.tests = list;
        this.total = total;
      } catch (error) {
        console.error(`Problem getting list of tests: ${error.message}`);
        Notifications.errorToast('Error Loading Tests', {duration: 30000, retry: this.load});
      }
      this.loading = false;
    },
    async deleteTest() {
      await Notifications.alert('Just no.');
    },
    to(route) {
      this.$router.push(route);
    },
    async detailItem(id) {
      this.to({path: `tests/${id}`});
    }
  },
  watch: {
    // eslint-disable-next-line
    search: _.debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      tests: [],
      search: '',
      total: 0,
      loading: false,
      skip: 0,
      limit: 10,
      sort: null,
      defaultSort: {account: 1, name: 1},
      headers: [
        {text: 'Account', value: 'account'},
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Tags', value: 'tags'},
        {text: 'Created', value: 'createdAt'},
        {text: 'Updated', value: 'updatedAt'},
        {text: 'Retries', value: 'retries'},
        {text: 'Reset Retry', value: 'hardResetOnRetry'},
        {text: '', value: 'actions', sortable: false}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
